// This file was automatically generated from ptdata.letterReceiptsNew.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.letterReceiptsNew');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.letterReceipts');
goog.require('el8.template.ptdata.lettersNew');
goog.require('el8.template.render.reportFeedItem.referralDetail');
goog.require('el8.template.shared.commentReplyForm');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letterReceiptsNew.summaryNew = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FeedItemColMainTopLine"><a class="letter-toggle-collapse-trigger">', (opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.senderName) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.senderName)) : soy.$$escapeHtml(opt_data.senderName)), ' <span class="el8LetterArrow"></span> ', soy.$$escapeHtml(opt_data.receiverName), '</a>', (opt_data.filedAsDocumentId) ? ' <a class="el8FeedItemHeaderLinkNew ml10 item-details-trigger" data-id="' + soy.$$escapeHtml(opt_data.filedAsDocumentId) + '">Open in Reports</a>' : '', ' <a class="el8FeedItemHeaderLinkNew ml10 letter-toggle-collapse-status letter-toggle-collapse-trigger">collapse status holder</a></div>', (opt_data.isPtLetter) ? '<div class="el8FeedColMainLine">Sent on: ' + (soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentDate)) : '') + ' at ' + (soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyTime(soy.$$escapeHtml(opt_data.documentDate)) : '') + '</div>' : (opt_data.sentDate && opt_data.signDate) ? '<div class="el8FeedColMainLine">Sent on: ' + (soy.$$escapeHtml(opt_data.sentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.sentDate)) : '') + '</div>' : '', '<div class="el8FeedColMainLine el8SingleLineText"><span class="el8555">');
  el8.template.ptdata.letterReceipts.subject(opt_data, output);
  output.append('</span>', (opt_data.body) ? (opt_data.isReferralLetter) ? '<span class="letter-body-preview ml5">Reason: ' + ((opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.body) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.body)) : soy.$$escapeHtml(opt_data.body))) + '</span>' : '<span class="letter-body-preview ml5">' + ((opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.body) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.body)) : soy.$$escapeHtml(opt_data.body))) + '</span>' : '', '</div><div class="letter-collapsible-section ebs-form-horizontal">', (opt_data.body) ? (opt_data.isReferralLetter) ? '<div class="el8FieldSection ebs-form-group"><label class="el8FieldMedium ebs-control-label ebs-col-sm-2">Reason:</label><div class="el8FieldMediumLabelPadding el8Wrap el8StandardFontSize el8Preserve ebs-col-sm-10">' + ((opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.body) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.body)) : soy.$$escapeHtml(opt_data.body))) + '</div></div>' : '<p class="el8Preserve mt10 mb20">' + ((opt_data.noHighlight) ? soy.$$escapeHtml(opt_data.body) : (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.body)) : soy.$$escapeHtml(opt_data.body))) + '</p>' : '', '<div class="mb20">');
  if (opt_data.isReferralLetter) {
    el8.template.render.reportFeedItem.referralDetail.contentReferralOrderDetail({authNumber: opt_data.authNumber, authorizationFor: opt_data.authorizationFor, icd9CodeObjs: opt_data.icd9CodeObjs, icd10CodeObjs: opt_data.icd10CodeObjs}, output);
  }
  output.append('</div><div>');
  if (opt_data.attachments.length) {
    output.append('<div class="el8FeedItemColMainSubHead">Attachments:</div>');
    el8.template.ptdata.letterReceipts.attachmentSection(opt_data, output);
  }
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letterReceiptsNew.feedIcon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isReferralLetter) ? '<div class="el8ChartFeedIconReferral"></div>' : (opt_data.isPtLetter) ? '<div class="el8ChartFeedIconPtLetter"></div>' : '<div class="el8ChartFeedIconLetter"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letterReceiptsNew.secondarySection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="letter-responses-section mb10">');
  el8.template.ptdata.letterReceiptsNew.commentSection(opt_data, output);
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letterReceiptsNew.commentSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.comments.length) {
    output.append('<div class="el8FeedItemColMainSubHead comment-count">');
    el8.template.ptdata.lettersNew.commentCount(opt_data, output);
    output.append('</div>');
  }
  output.append('<div class="el8MessageWrapper letter-comments"><ul class="el8ResponsesWrap ebs-list-unstyled">');
  var cList18927 = opt_data.comments;
  var cListLen18927 = cList18927.length;
  for (var cIndex18927 = 0; cIndex18927 < cListLen18927; cIndex18927++) {
    var cData18927 = cList18927[cIndex18927];
    el8.template.ptdata.lettersNew.comment(soy.$$augmentData(cData18927, {patientId: opt_data.patientId, noHighlight: opt_data.noHighlight}), output);
  }
  el8.template.shared.commentReplyForm.replyTrigger(opt_data, output);
  output.append('</ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.letterReceiptsNew.metadataCounts = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8CommentInfo">', (opt_data.comments.length) ? '<span class="el8IconComment"></span><span class="el8InlineBlock el8CommentData">' + soy.$$escapeHtml(opt_data.comments.length) + '</span>' : '', '</div>');
  if (!opt_sb) return output.toString();
};
